class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.productContainer = this.closest('article');
    this.form = this.querySelector('form');
    this.variantSelect = this.querySelector('[name=id]')
    this.buyButton = this.querySelector('[name=add]');
    this.cart = document.querySelector('cart-popup');
    
    if (!this.cart) return;
    
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  enable() {
    this.setButton(true, window.i18n.products.product.added_to_cart);

    setTimeout(() => {
      this.setButton(false, window.i18n.products.product.add_to_cart);
    }, window.durations.veryLong);
  }

  disable() {
    this.setButton(true, window.i18n.products.product.adding_to_cart);
  }

  selectedVariant() {
    return this.variantSelect.selectedOptions[0];
  }

  getVariantTitle() {
    return this.selectedVariant().dataset.titleFull;
  }

  getVariantURL() {
    return this.selectedVariant().dataset.urlFull
  }

  setButton(disabled, text) {
    this.buyButton.disabled = disabled;
    this.buyButton.innerHTML = "";
    let textElement = document.createElement("span");
    textElement.innerHTML = text;
    this.buyButton.appendChild(textElement);
  }

  checkRadioSelectsValidity() {
    if (!this.productContainer?.querySelector('radio-select')) return true;
    
    return Array.from(this.productContainer.querySelectorAll('radio-select')).every(radioSelect => {
      if (!radioSelect.querySelector(':checked')) {
        radioSelect.open();
        return false
      }

      return true;
    })
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    if (!this.checkRadioSelectsValidity()) return;

    this.disable();

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { 
        ...fetchConfig('javascript'), 
        body 
      })
      .then((response) => response.json())
      .then((parsedState) => {
        this.cart.render(parsedState);
      })
      .catch((e) => {
        console.error("ProductForm#onSubmitHandler", e);
      })
      .finally(() => {
        this.enable();
      });
  }
}

customElements.define('product-form', ProductForm);
